// Canonical list of screen-specific Jet event names forwarded via jetScreenSpecificEvent.
// The `: readonly EventName[]` annotation makes tsc fail if any name drifts from the SDK
// EventMap (each literal is checked against EventName on assignment). Kept in .ts (not the
// .js composable) so the check is actually type-checked (project runs checkJs:false).
import type { EventName } from '@/modules/Jet'

export const JET_SCREEN_EVENT_NAMES: readonly EventName[] = [
	'OnboardingWelcomeDone',
	'OnboardingAgeRangeSelectionDone',
	'OnboardingHeightSelectionDone',
	'OnboardingWeightSelectionDone',
	'OnboardingGoalWeightSelectionDone',
	'OnboardingBirthYearSelectionDone',
	'OnboardingGoalDateSelectionDone',
	'OnboardingEmailSubmitDone',
	'OnboardingHealthProblemRiskDone',
]
